@let inputElem = this.inputElem();

<label class="card-selectable mb-0">
  <div class="row gx-2">
    <div class="col">
      @if (inputElem.content?.title) {
        <p
          class="text-secondary"
          [ngClass]="{
            'mb-2': inputElem.content?.categories,
            'mb-0': !inputElem.content?.categories,
          }"
        >
          <b>{{ inputElem.content.title | translate }}</b>
        </p>
      }

      @if (inputElem.content?.categories) {
        <div class="row gx-3">
          @for (category of inputElem.content.categories; track category) {
            <div class="col-auto text-center">
              <mwe-product-icon [category]="category" size="md" textNodeType="p" />
            </div>
          }
          @if (inputElem.content.categories[0]) {
            <p class="text--legal mb-0 mt-2">
              {{ inputElem.content.categories[0] | correlatedCompanyReference }}
            </p>
          }
        </div>
      }

      @if (inputElem.content?.after) {
        <div>{{ inputElem.content.after | translate }}</div>
      }
    </div>
    <div class="col-auto">
      <input
        class="form-check-input"
        type="checkbox"
        mweClickPreventDefault
        [name]="inputElem.name"
        [formControl]="control()"
        [required]="isRequired() || null"
        [ngClass]="{
          'is-invalid': control().errors && !control().pristine,
          'form-check-readonly': isLoading() || inputElem.isReadonly,
        }"
        [ignorePreventClickDefault]="!inputElem.isReadonly"
        [attr.id]="inputElem.name"
        [attr.data-test]="'form-input-' + inputElem.name"
        [attr.aria-describedby]="ariaDescribedBy()"
        [attr.aria-invalid]="!isValid()"
        [attr.disabled]="inputElem.isDisabled ? '' : null"
        [attr.tabindex]="inputElem.isReadonly ? '-1' : null"
      />
    </div>
  </div>
</label>
